import { create } from 'zustand'

// История чата — только в памяти вкладки (не персистится). Дедуп по id:
// локальное оптимистичное сообщение и его эхо из data-канала не двоятся.
export interface ChatEntry {
  id: string
  text: string
  sentAt: number
  authorId: string
}

interface ChatState {
  messages: ChatEntry[]
  add: (entry: ChatEntry) => void
  clear: () => void
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  add: (entry) =>
    set((s) => {
      if (s.messages.some((m) => m.id === entry.id)) return {}
      return { messages: [...s.messages, entry] }
    }),
  clear: () => set({ messages: [] }),
}))
